/** Search and org switcher share this box so they line up in the top bar. */
export const TOPBAR_FIELD =
  'hidden md:flex flex-shrink-0 items-center gap-2 h-8 w-48 px-3 text-sm bg-muted/50 hover:bg-muted border border-border rounded-lg transition-colors';
